__turbopack_context__.v({
  "accordionSlideOverwrite": "calculator-module-scss-module__61-m5q__accordionSlideOverwrite",
  "actionButtons": "calculator-module-scss-module__61-m5q__actionButtons",
  "calculator": "calculator-module-scss-module__61-m5q__calculator",
  "errorMessage": "calculator-module-scss-module__61-m5q__errorMessage",
  "fadeIn": "calculator-module-scss-module__61-m5q__fadeIn",
  "fadeOut": "calculator-module-scss-module__61-m5q__fadeOut",
  "field": "calculator-module-scss-module__61-m5q__field",
  "form": "calculator-module-scss-module__61-m5q__form",
  "label": "calculator-module-scss-module__61-m5q__label",
  "output": "calculator-module-scss-module__61-m5q__output",
  "outputSection": "calculator-module-scss-module__61-m5q__outputSection",
  "scaleIn": "calculator-module-scss-module__61-m5q__scaleIn",
  "scaleOut": "calculator-module-scss-module__61-m5q__scaleOut",
  "section": "calculator-module-scss-module__61-m5q__section",
  "sectionTitle": "calculator-module-scss-module__61-m5q__sectionTitle",
  "zoomIn": "calculator-module-scss-module__61-m5q__zoomIn",
  "zoomOut": "calculator-module-scss-module__61-m5q__zoomOut",
});
